import UnfoldLessIcon from '@mui/icons-material/UnfoldLess'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import { Collapse } from '@mui/material'
import { useState } from 'react'
import { fetchSchemaTemplates } from '../editor/DropCreatorUtils'

export const SchemaSelectionElement = ({
    collectionName,
    schemaName,
    schemaTemplates,
    setSchemaTemplates,
    templateFilter,
    children,
}) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className="mb-5 border border-zinc-400 dark:!border-paperl bg-zinc-300 dark:!bg-paper rounded-md shadow-xl p-5">
            <div
                className="flex cursor-pointer hover:text-primary"
                onClick={() => {
                    fetchSchemaTemplates(
                        collectionName,
                        schemaName,
                        schemaTemplates,
                        setSchemaTemplates,
                        templateFilter,
                    )
                    setIsOpen(!isOpen)
                }}
            >
                <div className="my-auto">
                    {isOpen ? (
                        <UnfoldLessIcon color="primary" />
                    ) : (
                        <UnfoldMoreIcon color="primary" />
                    )}
                </div>
                <div className="my-auto ml-5 font-bold text-xl">
                    {schemaName}
                </div>
            </div>

            <Collapse in={isOpen}>
                <div className="mt-5">{children}</div>
            </Collapse>
        </div>
    )
}
